import { getCurrentPlatform, TargetPlatform } from '@/services/envService';

export function isHgUser(): boolean {
  const currentPlatform = getCurrentPlatform();
  return currentPlatform === TargetPlatform.HOMEGATE;
}

export function isIS24User(): boolean {
  const currentPlatform = getCurrentPlatform();
  return currentPlatform === TargetPlatform.IS24;
}
